module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "fm6"
    }
  }, [_c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CODE NAME: GRAND GUIGNOL")]), _vm._v(" is a work of fiction. Any similarities to any person, living or dead, is purely coincidental.")]), _vm._v(" "), _c('p', {
    staticClass: "extract1"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("GRAND GUIGNOL")]), _vm._v(": Term for a type of short gothic play emphasizing violence, horror, and terror. This macabre form of theater became popular in Parisian cabarets and theaters in the nineteenth century, especially at the Theatre du Grand Guignol. The gory tales of mayhem and carnage probably were named Grand Guignol because the violent plots of the bloody one-act plays, performed by actors on a legitimate stage, resembled those of the Punch-and-Judy-like puppet shows that featured a popular puppet named Guignol, whose name became synonymous with the kind of miniature theater commonplace in France at the time. Thus, Grand Guignol was a horror show for grown-ups instead of a rowdy puppet theater for tots. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Webster’s")]), _vm._v(" gives the phrase “grand-guignolism” as a synonym for horror.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e958e26c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grand_Guignol.vue
// module id = 75
// module chunks = 0